import React from 'react';

const StartTaskIcon = () => (
  <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_748_2181)">
      <rect width="14" height="14" fill="white" fillOpacity="0.01"/>
      <g clipPath="url(#clip1_748_2181)">
        <path d="M9.75024 2.74805C12.097 2.74818 14.0002 4.6513 14.0002 6.99805C14.0002 9.34484 12.097 11.2479 9.75024 11.248C7.59399 11.248 5.81294 9.6418 5.53638 7.56055H2.89087C2.66902 8.11048 2.12983 8.49795 1.50024 8.49805C0.672119 8.49805 0.000244141 7.82617 0.000244141 6.99805C0.000302886 6.16997 0.672155 5.49805 1.50024 5.49805C1.79901 5.49791 2.09138 5.5869 2.33911 5.75391C2.58684 5.92095 2.77898 6.1585 2.89087 6.43555H5.53735C5.81239 4.35434 7.59402 2.74805 9.75024 2.74805ZM9.34399 4.99805C9.27528 4.99805 9.21905 5.05435 9.21899 5.12305V6.4668H7.87524C7.80653 6.4668 7.7503 6.5231 7.75024 6.5918V7.4043C7.75024 7.47305 7.80649 7.5293 7.87524 7.5293H9.21899V8.87305C9.21899 8.9418 9.27524 8.99805 9.34399 8.99805H10.1565C10.2251 8.99792 10.2815 8.94172 10.2815 8.87305V7.5293H11.6252C11.6939 7.52917 11.7502 7.47297 11.7502 7.4043V6.5918C11.7502 6.52318 11.6939 6.46693 11.6252 6.4668H10.2815V5.12305C10.2814 5.05443 10.2251 4.99818 10.1565 4.99805H9.34399Z" fill="white"/>
      </g>
    </g>
    <defs>
      <clipPath id="clip0_748_2181">
        <rect width="14" height="14" fill="white"/>
      </clipPath>
      <clipPath id="clip1_748_2181">
        <rect width="14" height="14" fill="white"/>
      </clipPath>
    </defs>
  </svg>
);

export default StartTaskIcon; 